function getAbCookie(name) {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
}

function applyHideSectionsAbTest() {
  const variant = getAbCookie("ab_hide_sections");
  const shouldHide = variant !== "off";
  document
    .querySelectorAll('.related-products-container[data-ab-eligible="true"], .footer__content-top[data-ab-eligible="true"]')
    .forEach((el) => {
      el.classList.toggle("ab-hide-sections--hidden", shouldHide);
    });
}
